enum TableauxEnum {
	listeTaux = 'listeTaux'
}

export default TableauxEnum